import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef, ViewChildren, QueryList, inject } from '@angular/core';
import { APIService } from 'src/app/services/APIService/api.service';
import { first } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { SpinnerService } from 'src/app/services/Spinner/spinner.service';
import { ToastService } from 'src/app/services/toast.service';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { DndModule } from 'ngx-drag-drop';
import { CommonModule } from '@angular/common';
import { ClarityModule } from '@clr/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PlotlyPlotLokalComponent } from '../messungsdetaildialog/plotly-plot-local';
import JSZip from 'jszip';
//import { PlotlyPlotComponent } from '../../plotly-plot/plotly-plot.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-messungsdialog',
  templateUrl: './messunglwmdialog.component.html',
  styleUrls: ['./messunglwmdialog.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    DndModule,
    MrTranslatePipe,
    FormsModule,
    ReactiveFormsModule,
    PlotlyPlotLokalComponent,
  ],
})
export class MessungLaengswelligkkeitdialogComponent implements OnInit {
  private apiservice = inject(APIService);
  private spinner = inject(SpinnerService);
  private toastr = inject(ToastService);
  private changeDet = inject(ChangeDetectorRef);
  private mrTranslate = inject(MrTranslatePipe);

  ostammid: number;
  opruefid: number;
  name: string;
  selectedOption: number = 1;
  Object = Object;
  placeHolderHeight = 50;
  draganddropactive = false;
  layout: any;
  tolerance: number = 0.01;
  title = 'Wellenlänge [10-30]';
  wellenrange: any = [-0.1, 0.1];
  wellendtick: any = 0.02;

  graph: any = {
    layout: {
      autosize: true,
      hovermode: 'closest',
      showlegend: false,
      legend: { orientation: 'h' },
      height: 250,
      margin: {
        l: 35,
        r: 20,
        b: 25,
        t: 20,
        pad: 0,
      },
      plot_bgcolor: 'transparent',
      paper_bgcolor: 'transparent',
    },
    config: {
      responsive: true,
      displaylogo: false,
      locale: 'de',
      modeBarButtonsToRemove: [
        'sendDataToCloud',
        'lasso2d',
        'autoScale2d',
        'toggleSpikelines',
        'hoverCompareCartesian',
        'hoverClosestCartesian',
      ],
    },
    m: [],
    show: {},
    y: [],
    data: [
      {
        name: 'Frequenz [10-30]',
        key: '',
        yData: [],
      },
      {
        name: 'Abweichung in %',
        key: '',
        yData: [],
      },
      {
        name: 'nötiger Abtrag in mm',
        key: '',
        yData: [],
      },
    ],
  };
  public closedialog: BehaviorSubject<boolean> = new BehaviorSubject(false);

  @ViewChildren('plotCmp') plotComponents!: QueryList<PlotlyPlotLokalComponent>;

  set data(dataIn: any) {
    this.ostammid = dataIn.id;
    this.opruefid = dataIn.opruefid;
    this.name = dataIn.name;
  }

  onWavelengthChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const value = selectElement.value; // "1", "2", "3" oder "4"

    console.log('Ausgewählte Option (ID):', value);
    console.log('Über ngModel synchronisiert:', this.selectedOption);

    switch (value) {
      case '1': // 10-30
        this.tolerance = 0.01;
        this.title = 'Wellenlänge [10-30]';
        this.wellenrange = [-0.1, 0.1];
        this.wellendtick = 0.02;
        break;
      case '2': // 30-100
        this.tolerance = 0.01;
        this.title = 'Wellenlänge [30-100]';
        this.wellenrange = [-0.3, 0.3];
        this.wellendtick = 0.04;
        break;
      case '3': // 100-300
        this.tolerance = 0.015;
        this.title = 'Wellenlänge [100-300]';
        this.wellenrange = [-0.5, 0.5];
        this.wellendtick = 0.1;
        break;
      case '4': // 300-1000
        this.tolerance = 0.075;
        this.title = 'Wellenlänge [300-1000]';
        this.wellenrange = [-1.5, 1.5];
        this.wellendtick = 0.3;
        break;
      default:
        this.tolerance = 0.01;
        this.title = 'Wellenlänge [10-30]';
        this.wellenrange = [-0.1, 0.1];
        this.wellendtick = 0.02;
        break;
    }

    this.loadMessung(parseInt(value));
  }

  loadMessung(typ: number) {
    this.spinner.enable();
    this.graph.data[0].show = false;

    this.apiservice
      .getMessungLaengswelligkeit(this.opruefid, typ)
      .pipe(first())
      .subscribe((res: any) => {
        var jsZip = typeof (<any>JSZip).default === 'function' ? new (<any>JSZip).default() : new JSZip();
        jsZip
          .loadAsync(res)
          .then(zip => {
            return zip.file('tmp.txt').async('string');
          })
          .then(async zipf => {
            let measurements = JSON.parse(zipf);

            let riffelResult = measurements['riffel'];
            const binaryString = atob(riffelResult.data);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }

            const blob = new Blob([bytes]);
            const decompressionStream = blob.stream().pipeThrough(new DecompressionStream('gzip'));
            const response = new Response(decompressionStream);
            const jsonText = await response.text();
            const rawData = JSON.parse(jsonText);

            if (!rawData['m'] || !rawData['m'].length) {
              this.spinner.disable();
              this.toastr.warning(this.mrTranslate.transform('Keine Daten vorhanden'));
              this.close();
              return;
            }

            let firstm = rawData['m'][0];
            let lastm = rawData['m'][rawData['m'].length - 1];
            let abweichung_L_m = [];
            let abweichung_L_val = [];
            let abweichung_R_m = [];
            let abweichung_R_val = [];
            let abtrag_L_val = [];
            let abtrag_R_val = [];

            let abweichung = measurements['abweichung'].rows;
            abweichung.forEach(row => {
              abweichung_L_m.push(row['start']);
              abweichung_R_m.push(row['start']);
              abweichung_L_val.push(row['abweichung_links']);
              abweichung_R_val.push(row['abweichung_rechts']);
              abtrag_L_val.push(row['abtrag_links']);
              abtrag_R_val.push(row['abtrag_rechts']);
            });

            let curlayout = {
              autosize: true,
              hovermode: 'closest',
              showlegend: true,
              legend: { orientation: 'h' },
              height: 250,
              margin: {
                l: 35,
                r: 20,
                b: 45,
                t: 20,
                pad: 0,
              },
              plot_bgcolor: 'transparent',
              paper_bgcolor: 'transparent',
              yaxis: {
                range: this.wellenrange,
                dtick: this.wellendtick,
              },
              xaxis: {
                range: [firstm, lastm],
                tick0: 0,
              },

              shapes: [
                {
                  type: 'line',
                  xref: 'paper',
                  x0: 0,
                  x1: 1,
                  y0: this.tolerance,
                  y1: this.tolerance,
                  line: {
                    color: 'rgb(255, 65, 54)',
                    width: 1.5,
                  },
                },
                {
                  type: 'line',
                  xref: 'paper',
                  x0: 0,
                  x1: 1,
                  y0: -this.tolerance,
                  y1: -this.tolerance,
                  line: {
                    color: 'rgb(255, 65, 54)',
                    width: 1.5,
                  },
                },
              ],
            };

            let newPlotleft: any = {
              name: 'links',
              visible: true,
              type: 'scatter',
              marker: {
                size: Number.MIN_VALUE,
              },
              mode: 'line',
              x: rawData['m'],
              y: rawData['left'],
            };
            let newPlotright: any = {
              name: 'rechts',
              visible: true,
              type: 'scatter',
              marker: {
                size: Number.MIN_VALUE,
              },
              mode: 'line',
              x: rawData['m'],
              y: rawData['right'],
            };

            this.graph.data[0].name = this.title;
            this.graph.data[0].yData = [newPlotleft, newPlotright]; // Setzt das Array direkt auf das neue Plot-Objekt
            this.graph.data[0].layout = curlayout;

            let curlayout1 = {
              autosize: true,
              hovermode: 'closest',
              showlegend: true,
              legend: { orientation: 'h' },
              height: 250,
              margin: {
                l: 35,
                r: 20,
                b: 45,
                t: 20,
                pad: 0,
              },
              plot_bgcolor: 'transparent',
              paper_bgcolor: 'transparent',
              xaxis: {
                range: [firstm, lastm],
                tick0: 0,
              },
              yaxis: {
                range: [0, 60],
                dtick: 20,
              },

              shapes: [
                {
                  type: 'line',
                  xref: 'paper',
                  x0: 0,
                  x1: 1,
                  y0: 5,
                  y1: 5,
                  line: {
                    color: 'rgb(255, 65, 54)',
                    width: 1.5,
                  },
                },
              ],
            };

            let newPlotleft1: any = {
              name: 'links',
              visible: true,
              type: 'scatter',
              marker: {
                size: Number.MIN_VALUE,
              },
              mode: 'line',
              x: abweichung_L_m,
              y: abweichung_L_val,
            };
            let newPlotright1: any = {
              name: 'rechts',
              visible: true,
              type: 'scatter',
              marker: {
                size: Number.MIN_VALUE,
              },
              mode: 'line',
              x: abweichung_R_m,
              y: abweichung_R_val,
            };

            this.graph.data[1].name = 'Abweichung in %';
            this.graph.data[1].yData = [newPlotleft1, newPlotright1]; // Setzt das Array direkt auf das neue Plot-Objekt
            this.graph.data[1].layout = curlayout1;

            let curlayout2 = {
              autosize: true,
              hovermode: 'closest',
              showlegend: true,
              legend: { orientation: 'h' },
              height: 250,
              margin: {
                l: 35,
                r: 20,
                b: 45,
                t: 20,
                pad: 0,
              },
              plot_bgcolor: 'transparent',
              paper_bgcolor: 'transparent',
              xaxis: {
                range: [firstm, lastm],
                tick0: 0,
              },
              yaxis: {
                range: [0, 0.5],
                dtick: 0.1,
              },
            };

            let newPlotleft2: any = {
              name: 'links',
              visible: true,
              type: 'scatter',
              marker: {
                size: Number.MIN_VALUE,
              },
              mode: 'line',
              x: abweichung_L_m,
              y: abtrag_L_val,
            };
            let newPlotright2: any = {
              name: 'rechts',
              visible: true,
              type: 'scatter',
              marker: {
                size: Number.MIN_VALUE,
              },
              mode: 'line',
              x: abweichung_R_m,
              y: abtrag_R_val,
            };

            this.graph.data[2].name = 'nötiger Abtrag in mm';
            this.graph.data[2].yData = [newPlotleft2, newPlotright2]; // Setzt das Array direkt auf das neue Plot-Objekt
            this.graph.data[2].layout = curlayout2;

            this.graph.data[0].show = true;

            this.spinner.disable();
          });
      });
  }

  constructor() {
    this.graph.m = [];
    this.graph.y = [];
  }

  getGraphIndex(key: string): number {
    for (var i = 0; i < this.graph.data.length; i++) {
      if (this.graph.data[i].key == key) {
        return i;
      }
    }
    return undefined;
  }

  applyYaxis(name: string) {
    let ind = this.getGraphIndex(name);
    this.graph.data[ind].show = false;
    this.changeDet.detectChanges();
    this.graph.data[ind].show = true;
  }

  public close() {
    this.graph = [];
    this.closedialog.next(true);
  }

  ngOnInit() {
    this.loadMessung(1);
  }

  shrink(graphData: any) {
    // Reset all cards
    this.graph.data = this.graph.data.map(d => ({
      ...d,
      fullsize: false,
      layout: { ...d.layout, height: 250 }, // reset height
    }));

    // Wait for Angular to apply DOM changes
    setTimeout(() => {
      const cmp = this.plotComponents.find(p => p.id() === graphData.key);
      cmp?.resizePlot();
    }, 100); // 100ms is safer
  }

  resize(graphData: any) {
    // Reset all cards
    this.graph.data = this.graph.data.map(d => ({
      ...d,
      fullsize: false,
      layout: { ...d.layout, height: 250 }, // reset height
    }));

    // Expand selected card
    const ind = this.getGraphIndex(graphData.key);
    const card = this.graph.data[ind];
    this.graph.data[ind] = {
      ...card,
      fullsize: true,
      layout: { ...card.layout, height: 620 }, // set height immutably
    };

    // Wait for Angular to apply DOM changes
    setTimeout(() => {
      const cmp = this.plotComponents.find(p => p.id() === graphData.key);
      cmp?.resizePlot();
    }, 100); // 100ms is safer
  }
}
